// Environment-specific configuration
const config = {
  // API base URL - default to localhost for development
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8001',
  
  // Electric URL for database sync
  ELECTRIC_URL: import.meta.env.VITE_ELECTRIC_URL || 'http://localhost:3000',
  
  // Google Client ID with validation
  GOOGLE_CLIENT_ID: (() => {
    // Get from environment variables
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
      
    if (!clientId) {
      console.error('Missing VITE_GOOGLE_CLIENT_ID in environment variables');
      throw new Error('Missing VITE_GOOGLE_CLIENT_ID in environment variables');
    }
    
    // Validate client ID format
    if (!clientId.endsWith('.apps.googleusercontent.com')) {
      console.error('Invalid VITE_GOOGLE_CLIENT_ID format:', clientId);
      throw new Error('Invalid VITE_GOOGLE_CLIENT_ID format. Should end with .apps.googleusercontent.com');
    }
    
    return clientId;
  })(),
  
  // Other configuration values
  TOKEN_BUFFER_TIME: 300000, // 5 minutes in milliseconds
} as const;

// Log configuration in development (but mask sensitive values)
if (import.meta.env.DEV) {
  console.log('App config:', {
    ...config,
    GOOGLE_CLIENT_ID: config.GOOGLE_CLIENT_ID.substring(0, 8) + '...'
  });
}

export default config; 